import Box from "@mui/material/Box";
import {StudyNoteBasicCard} from "./study-note-basic-card";
import {useState} from "react";
import {Grid} from "@mui/material";
import {StudyNoteFullInfo} from "./study-full-info";

export const ListStudyNotes = ({ notes }) => {
    const [showFullDialog, setShowFullDialog] = useState(false);
    const [selectedNote, setSelectedNote] = useState(undefined);

    const view = (note) => {
        setSelectedNote(note);
        setShowFullDialog(true)
    }

        return (
            <div>

                {
                    notes.length > 0 ?
                        <Box sx={{flexGrow: 1, textAlign: 'center'}} marginLeft={{ xs: '2.2rem', md: 'auto'}}>
                            <Grid container spacing={2}>
                                {
                                    notes
                                        .map((note) => <Grid key={note.id} item xs={8} md={4} sm={6} lg={3}>
                                            <StudyNoteBasicCard note={note} viewNote={view}/>
                                        </Grid>)
                                }
                            </Grid>
                        </Box>
                        :
                        null
                }

                {
                    selectedNote ?
                        <StudyNoteFullInfo note={selectedNote} open={showFullDialog} setOpen={setShowFullDialog} />
                        : null
                }

            </div>
        )
}
